import { Col, Container, Row } from "react-bootstrap"
import styled from "styled-components"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"
import { Trans, useTranslation } from "~/i18n"
import getcdn from "~/modules/get_cdn_link"
import Button from "~/components/UI/Button"
import { COLORS } from "~/components/UI/Constants"
import { BoxDetails } from "./Saving"
import Image from "~/components/UI/Image"
import { IStyleElement } from "~/types/types"
import { ROUTES } from "~/constant"
import config from "~/stores/Config"
import { observer } from "mobx-react-lite"

const MyContainer = styled(Box)`
  margin-bottom: 60px;
`

const CD = () => {
  const [t] = useTranslation()
  const attrs: IStyleElement = { xsStyle: { textAlign: 'center' }, mdStyle: { textAlign: 'left' } }
  return (
    <MyContainer>
      <Container style={{ padding: 0 }}>
        <Row>
          <Col md={6}>
            <Box justify='center' style={{ paddingLeft: '2%' }} flex column height='100%'>
              <Text {...attrs} style={{ lineHeight: 1.2, marginTop: 20 }} bold size={36} lgSize={48} xlSize={56}>
                <Trans key='Tích luỹ linh hoạt'>
                 {t`Đầu tư`}
                  <br />
                  <span style={{ color: COLORS.PRIMARY }}>{t`Chứng chỉ tiền gửi`}</span>
                </Trans>
              </Text>
              <Text
                {...attrs}
                margin='20px 0'>
                {t('Đầu tư chứng chỉ tiền gửi với lãi suất cao được phát hành bởi các tổ chức tín dụng uy tín. Rút vốn trước hạn vẫn nhận lãi tương đương gửi ngân hàng.')}
              </Text>

              <BoxDetails
                style={{
                  backgroundColor: '#f3f7fe',
                  borderColor: 'rgba(0, 0, 0, 0.1)',
                }}
                flex justify='space-between' align='center'>
                <Box height='auto'>
                  <Text >
                    {t('Lợi nhuận')}
                  </Text>
                  <Text size={18} lgSize={24} bold >
                    {config.cd?.interest + '%/' + t('năm')}
                  </Text>
                </Box>

                <Box height='auto'>
                  <Text >
                    {t('Kỳ hạn')}
                  </Text>
                  <Text size={18} lgSize={24} bold >
                    {t('12 tháng')}
                  </Text>
                </Box>

                <Box height='auto'>
                  <Text >
                    {t('Vốn tối thiểu')}
                  </Text>
                  <Text size={18} lgSize={24} bold >
                    {t('500 nghìn')}
                  </Text>
                </Box>
              </BoxDetails>

              <Button
                maxWidth='100%'
                target='_blank'
                rel="noreferrer"
                link href={ROUTES.CD_INFO}
                border='0'
                mdStyle={{ justifyContent: 'flex-start' }}>
                <Text bold >
                  {t('Tìm hiểu thêm →')}
                </Text>
              </Button>
            </Box>

          </Col>
          <Col md={6}>
            <Image
              xsStyle={{ margin: 'auto', width: '100%', height: '100%' }}
              layout='fill'
              objectFit='contain'
              src={getcdn('/images/home/cd_ipad.jpg')} alt='ipad_cd' />
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default observer(CD)
